// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var ask = /* #__PURE__ */ Control_Monad_Reader_Class.ask(Specular_Dom_Builder.monadAskBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var newDynamic = /* #__PURE__ */ Specular_FRP_Base.newDynamic(Effect_Class.monadEffectEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder));
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Class.monadEffectEffect);
var log = /* #__PURE__ */ Effect_Class_Console.log(Effect_Class.monadEffectEffect);
var keyedList = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return function (tagName) {
        return function (containerProps) {
            return function (dyn) {
                return function (keyFn) {
                    return function (renderItem) {
                        return bind(ask)(function (env) {
                            return bind(Specular_Dom_Element["el$prime"](tagName)(containerProps)(Restaumatic_Prelude_Specular.wempty))(function (v) {
                                return bind(liftEffect(function () {
                                    return $foreign.init(v.value0, function ($34) {
                                        return show(keyFn($34));
                                    }, function (initialIndex, item) {
                                        var ix = newDynamic(initialIndex)();
                                        var v1 = renderItem(ix.dynamic)(item);
                                        var v2 = Specular_Dom_Builder.runBuilder(v.value0)(Specular_Dom_Builder.local(function (v2) {
                                            return env;
                                        })(Specular_Dom_Element["el$prime"](v1.tag)(v1.props)(v1.body)))();
                                        return {
                                            node: v2.value0.value0,
                                            cleanup: v2.value1,
                                            updateIndex: Effect_Uncurried.mkEffectFn1(ix.set)
                                        };
                                    });
                                }))(function (impl) {
                                    return discard1(onCleanup(function () {
                                        return $foreign.cleanup(impl);
                                    }))(function () {
                                        return Data_Function.flip(subscribeDyn_)(dyn)(function (items) {
                                            return function __do() {
                                                liftEffect1(log("keyedList dyn refresh"))();
                                                return $foreign.synchronize(impl, items);
                                            };
                                        });
                                    });
                                });
                            });
                        });
                    };
                };
            };
        };
    };
};
export {
    keyedList
};
